// extracted by mini-css-extract-plugin
export default {"scope":"theme_scope__9ef-2"};